import React, {useEffect} from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import DashboardCounts from './DashboardCounts'
import { UserRightsDisplay } from './UserRightsDisplay'
import { TicketListPage } from '../Tickets'
import {useDispatch, useSelector} from 'react-redux'
import { is_superuser } from '../../helpers'
import {OrganizationService} from "../../services";
import {setDefaultOrganization} from "../../state/token";
import {showSuccessToast} from "../../state/toasts";
import {RootState} from "../../state/reducer";
import './style.css'
export const DashboardPage = () => {
  const dispatch = useDispatch()
  const { user } = useSelector((state:RootState) => state.auth)
  const { organization } = useSelector((state:RootState) => state.machineConfig)
  const { geoLocation } = useSelector((state:RootState) => state.application)
  let filters:{status_in:string,organization?:string} = {
    status_in: 'Registered,Under Progress,Ready,Hold,Ready For Pickup',
  }
  if (!is_superuser(user) && organization) {
    filters.organization = organization.code
  }
  useEffect(()=>{
    !organization && new OrganizationService().guess_my_location(geoLocation).then((res)=>{
       console.log(res)
         dispatch(setDefaultOrganization(res))
        dispatch(showSuccessToast("Success",`Your default location has been set to ${res?.code}`))
    })
  },[])
  return (
    <ReactBootstrap.Col className="p-0">
    <DashboardCounts />
      <ReactBootstrap.Row className="mt-5">
        <ReactBootstrap.Col xs={12} md={4}>
          <UserRightsDisplay />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12} md={8}>
          <TicketListPage
            title={
              !is_superuser(user) && organization
                ? `Open Tickets at ${organization.code}`
                : 'Open Tickets'
            }
            defaultFilters={filters}
            showOnlyPages={true}
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </ReactBootstrap.Col>
  )
}
